import { render, staticRenderFns } from "./DeleteAttachmentCategoryDialog.vue?vue&type=template&id=c088e06c&"
import script from "./DeleteAttachmentCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteAttachmentCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports